export default __webpack_public_path__ + "static/media/default_profile.b832cfe0.png";